export default import.meta.ROLLDOWN_FILE_URL_mIrOmZX$EjcQAaU9wsxwng